import { ENV } from '../constants';

const firebaseProdConfig = {
    apiKey: 'AIzaSyA_len8uK2v_1NI9wVbYgF2Fo42SBHmUko',
    authDomain: 'sf-cinema.firebaseapp.com',
    databaseURL: 'https://sf-cinema.firebaseio.com',
    storageBucket: 'sf-cinema.appspot.com',
    messagingSenderId: '731844528747'
};

const firebaseDevConfig = {
    apiKey: 'AIzaSyDtySRDSz7m8fAGDp0I-i06YQctkoh22rM',
    authDomain: 'sf-cinemacity-dev.firebaseapp.com',
    databaseURL: 'https://sf-cinemacity-dev.firebaseio.com',
    projectId: 'sf-cinemacity-dev',
    storageBucket: 'sf-cinemacity-dev.appspot.com',
    messagingSenderId: '229677770352'
};

export default ENV === 'production' ? firebaseProdConfig : firebaseDevConfig;
